module.exports = __webpack_public_path__ + "pangu/img/noTableData.png";